import React from "react";
import DashboardBarChart from "../../common/DashboardBarChart";

const ProgressTracking = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg  shadow-sm animate-pulse">
        <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div>
        <div className="h-64 bg-gray-200 rounded"></div>
      </div>
    );
  }
  const stagesData = data?.criticalStagesCompletion
    ? Object.entries(data.criticalStagesCompletion)
        .map(([stage, count]) => {
          const labelMap = {
            procurementCompleted: "Procurement",
            siteSelectionCompleted: "Site Selection",
            mouSigned: "MOU Signed",
            materialsCompleted: "Materials",
            omCompleted: "OM Completed",
            qaInspectionCompleted: "QA Inspection",
          };

          const colorMap = {
            procurementCompleted: "#3B82F6", 
            siteSelectionCompleted: "#10B981", 
            mouSigned: "#8B5CF6",
            materialsCompleted: "#F59E0B",
            omCompleted: "#EF4444",
            qaInspectionCompleted: "#EC4899",
          };

          const sequenceMap = {
            procurementCompleted: 1,
            siteSelectionCompleted: 2,
            mouSigned: 3,
            materialsCompleted: 4,
            omCompleted: 5,
            qaInspectionCompleted: 6,
          };

          return {
            name: labelMap[stage] || stage,
            value: count || 0,
            color: colorMap[stage] || "#6B7280",
            sequence: sequenceMap[stage] || 0,
          };
        })
        .sort((a, b) => a.sequence - b.sequence)
    : [];

  const totalStages = stagesData.reduce((sum, item) => sum + item.value, 0);
  const overallCompletion = parseFloat(data?.overallCompletionRate || 0);
  const avgTime = data?.averageImplementationTime || 0;


  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h3 className="text-lg font-semibold text-gray-800 text-balance">
            Progress Tracking
          </h3>
          {/* <p className="text-sm text-gray-600">
            Implementation stages completion overview
          </p> */}
        </div>
        {/* <div className="text-right">
          <div className="text-2xl font-bold text-green-600">
            {overallCompletion.toFixed(1)}%
          </div>
          <div className="text-sm text-gray-600">Overall Progress</div>
        </div> */}
      </div> 

      <div className="mb-6">
        <DashboardBarChart
          horizontal
          items={stagesData.map((stage) => ({ name: stage.name, count: stage.value }))}
          unit="implementations"
        />
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="bg-[#E6F2F2] rounded-lg p-4 text-center">
          <div className="text-xs text-[#0B5557] mb-1">Total Stages</div>
          <div className="text-xl font-bold text-[#137E81]">{totalStages}</div>
        </div>
        <div className="bg-[#E6F2F2] rounded-lg p-4 text-center">
          <div className="text-xs text-[#0B5557] mb-1">Avg. Time</div>
          <div className="text-xl font-bold text-[#137E81]">{avgTime}d</div>
        </div>
        <div className="bg-[#E6F2F2] rounded-lg p-4 text-center">
          <div className="text-xs text-[#0B5557] mb-1">Completion</div>
          <div className="text-xl font-bold text-[#137E81]">
            {overallCompletion.toFixed(1)}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressTracking;
